/**
 * @overview 场地预约记录
 * @author jzhu
 * @date 2020-8-14
 */

import React from 'react'
import { connect } from 'dva'
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool
let { WizBrowserExport } = component_tool
let { Storage } = utils_tool

class SiteOrderRecord extends WizContainer {

    componentName = 'SiteOrderRecord'

    constructor(props) {
        super(props)
        this.state = {
        }
    }

    _columns = () => {
        let defaultProps = {
            cellStyle: {
                textAlign: 'center',
            },
            style: {
                alignment: { vertical: 'bottom', horizontal: 'left' },
            }
        }
        return [
            {
                headerName: '',
                width: 30,
                field: 'rowIndex',
                hidden: true,
                suppressMovable: true,
                cellStyle: {
                    textAlign: 'center',
                    padding: '5px 0',
                    color: '#595959',
                    backgroundColor: '#f0f0f0',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '500',
                    boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
                },
            },
            {
                headerName: '预约编号',
                field: 'number',
                width: 20,
                ...defaultProps
            },
            {
                headerName: '场地名称',
                field: 'name',
                width: 20,
                ...defaultProps
            },
            {
                headerName: '场地编号',
                field: 'code',
                width: 20,
                ...defaultProps
            },
            {
                headerName: '预约日期',
                field: 'date',
                width: 40,
                ...defaultProps
            },
            {
                headerName: '预约人',
                field: 'fullName',
                width: 15,
                ...defaultProps
            },
            {
                headerName: '联系电话',
                field: 'orderMobile',
                width: 15,
                ...defaultProps
            },
            {
                headerName: '使用类型',
                field: 'useTypeMessage',
                width: 10,
                ...defaultProps
            },
            {
                headerName: '申请状态',
                field: 'statusMessage',
                width: 10,
                ...defaultProps
            }
        ]
    }

    _export = (nextProps, nextState, key) => {
        let o = nextProps[key]
        if (o.success) {
            let columns = this._columns()
            WizBrowserExport({
                title: '预约历史记录',
                sheetName: '预约历史记录',
                columns: columns.filter((_, index) => index),
                rows: o.data,
                filename: '预约历史记录.xlsx',
            })
            return true
        } else {
            wizNotice.error(o.msg)
            return false
        }
    }

    _cancel = (nextProps, nextState, key) => {
        let o = nextProps[key]
        if (o.success) {
            wizNotice.success('操作成功')
        } else {
            wizNotice.error(o.msg)
        }
        return true
    }

    _userInfo = () => {
        let user = Storage.getStorage('user') || {}
        return user
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig,
            apiDataFormat: {
                export: this._export,
                cancel: this._cancel
            },
            self: this
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}

export default connect(mapStateToProps)(SiteOrderRecord)
